import React from 'react';

import BaseModel from "../base_model.js.jsx";
import I18n from "../../base/i18n.js.jsx";

import MoneyFormatter from "../../utils/money_formatter.js.jsx";

import TextCell from "../../base/table/cells/text_cell.js.jsx";
import BooleanCell from "../../base/table/cells/boolean_cell.js.jsx";

import { DownloadableModel } from "./downloadable_model.js.jsx";
import UserInfoCell from '../../base/table/cells/special_cells/user_info_cell.js.jsx';
import PaymentMethodCell from "../../base/table/cells/special_cells/payment_method_cell.js.jsx";
import ModelCell from "../../base/table/cells/model_cell.js.jsx";

import Routes from "../../admin/routes.js.jsx";

class RawDownloadableSubscriberModel extends BaseModel {

  rawListFields() {
    return [
      {
        name: "participantDownloadable",
        displayName: this.fieldDisplayName("participantDownloadable"),
        renderFunction: (subscriber, column, onChangeColumn) => {
          if(subscriber.hideDownloadableInfo) {
            return <div/>
          }
          const downloadableColumn = {
            ...column,
            type: "model",
            model: DownloadableModel,
            urlFunc: Routes.downloadable
          }

          let downloadable;
          if(subscriber.participantDownloadable) {
            downloadable = subscriber.participantDownloadable;
          }
          else {
            const participant = subscriber.participant || {};
            downloadable = participant.downloadable;
          }

          return <ModelCell column = { downloadableColumn }
                            value = { downloadable }
                            onChange = { onChangeColumn } />
        }
      },
      {
        name: "user",
        displayName: this.fieldDisplayName("user"),
        renderFunction: subscriber => {
          if(subscriber.hideUserInfo) {
            return <div/>
          }
          const participant = subscriber.participant || {};
          const { user } = participant;
          return <UserInfoCell user = { user } />
        }
      },
      {
        name: "email",
        displayName: this.fieldDisplayName("email"),
        type: "text",
      },
      {
        name: "createdAt",
        displayName: this.fieldDisplayName("downloadedAt"),
        type: "dateTime",
        dateFormat: "DD.MM.YYYY",
        timeFormat: "HH:mm"
      },
    ]
  }



  i18nScope() {
    return "model.downloadables.subscriber";
  }

}
const DownloadableSubscriberModel = new RawDownloadableSubscriberModel();

export { RawDownloadableSubscriberModel, DownloadableSubscriberModel }
